import React from "react";
import "./project-card.css";
function ProjectCard({ project }) {
  return (
    <div className="project-card">
      <div className="project-info">
        <div className="project-header">
          <label className="project-title">{project.title}</label>
          <div className="project-meta">
            <span className="project-role">{project.role}</span>
            <span className="project-duration">{project.duration}</span>
          </div>
        </div>
        {project.links && project.links.length > 0 && (
          <div className="project-site-links">
            {project.links.map((link) => (
              <a
                className="site-link"
                href={link.url}
                target="_blank"
                rel="noreferrer"
                key={link.url}
              >
                <i className="fi fi-rr-globe"></i>
                {link.label}
              </a>
            ))}
          </div>
        )}
        <div className="project-links">
          {project.demo && project.demo !== "#" && (
            <a className="project-link" href={project.demo}>
              <div className="link-button">
                <i class="fi-rr-globe"></i>Demo
              </div>
            </a>
          )}
          {project.github && project.github !== "#" && (
            <a className="project-link" href={project.github}>
              <div className="link-button">
                <i class="devicon-github-original colored"></i>Github
              </div>
            </a>
          )}
        </div>
        <div className="project-description">
          <h4>Project Overview:</h4>
          <p>{project.about}</p>
        </div>
        {project.contributions && (
          <div className="project-contributions">
            <h4>My Contributions:</h4>
            <ul>
              {project.contributions.map((contribution, index) => (
                <li
                  key={index}
                  dangerouslySetInnerHTML={{ __html: contribution }}
                ></li>
              ))}
            </ul>
          </div>
        )}
        <div className="project-tags">
          {project.tags.map((tag) => {
            return (
              <label className="tag" key={tag}>
                {tag}
              </label>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default ProjectCard;
